import { Component, OnInit } from '@angular/core';
import {Http, Response, Headers, RequestOptions} from "@angular/http";

@Component({
  selector: 'app-careers',
  templateUrl: './careers.component.html',
  styleUrls: ['./careers.component.css']
})
export class CareersComponent implements OnInit {

  private job_list: job_adv[];

  constructor(private _http:Http) { }


  ngOnInit() {
    this._http.get("assets/jobs/jobs-list.jsn")
      .subscribe(
        (response:any) => this.job_list = response.json(),
        (error:any)=> console.log('The error: ',error)
      )
  }

}



// WEBPACK FOOTER //
// ./src/app/careers/careers.component.ts